import React from "react";
import CloseIcon from "../icons/CloseIcon";
import Button from "./Button";

/* Canonical close button for every modal/sheet on the site. Matches the
   header's user-icon button (white card, navy icon, gray border, navy-fill
   on hover/focus/active) but renders ~28px instead of 36px so the close
   affordance sits a touch smaller than nav-level icon buttons. Always
   `rounded-lg`, never `rounded-full`. */

export type ModalCloseButtonProps =
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "children" | "type" | "color"> & {
    /** Required for screen-reader accessibility. */
    "aria-label": string;
  };

const BASE_CLS =
  "inline-flex h-7 w-7 items-center justify-center rounded-lg border " +
  "border-neutral-10 bg-constant-white text-blue-100 " +
  "transition-colors duration-200 ease-out select-none focus:outline-none " +
  "hover:bg-blue-100 hover:border-blue-100 hover:text-constant-white " +
  "focus-visible:bg-blue-100 focus-visible:border-blue-100 focus-visible:text-constant-white " +
  "active:bg-blue-100 active:border-blue-100 active:text-constant-white " +
  "disabled:cursor-not-allowed disabled:opacity-50";

export default function ModalCloseButton({
  className = "",
  ...props
}: ModalCloseButtonProps) {
  return (
    <Button
      raw
      type="button"
      data-no-lift
      className={`${BASE_CLS} ${className}`.trim()}
      {...props}
    >
      <CloseIcon size={14} color="currentColor" className="h-3.5 w-3.5" />
    </Button>
  );
}
